import RestClient from './RestClient';
import { Article } from '../../models';
import { getApiErrorMessage } from './getApiErrorMessage';

class Articles extends RestClient {
    constructor() {
        super({
            "model": Article,
            "entryPoint": "article",
            "resource": "article",
            "resources": "articles",
            "id_field": "_id"
        });
    }

    previewImportStocks(file) {
        const form_data = new FormData();
        form_data.append('file', file);

        return this.POSTMultipart('/article/preview_import_stocks', form_data)
            .then(response => response.json())
            .then(json => {
                if (json.preview)
                    return json.preview;
                throw new Error(getApiErrorMessage(json, undefined, this.get_last_request_id?.()));
            });
    }

    stockMovements(id) {
        return this.GET(`/article/stock_movements/id/${id}`)
            .then(response => this.parseResponseJson(response))
            .then(json => json.movements || []);
    }

    importStocks(file) {
        const form_data = new FormData();
        form_data.append('file', file);

        return this.POSTMultipart('/article/import_stocks', form_data)
            .then(response => response.json())
            .then(json => {
                if (json.result)
                    return json.result;
                throw new Error(getApiErrorMessage(json, undefined, this.get_last_request_id?.()));
            });
    }
}

const ArticlesApi = new Articles();

export default ArticlesApi;
